import React from 'react';
import Container from 'react-bootstrap/Container';

function Footer() {
  return (
    <footer className='bg-primary'>
      <Container>
        <p className='text-light text-center m-0 py-3'>
          Alexandru Leiba Lapteacru © 2021
        </p>
      </Container>
    </footer>
  );
}

export default Footer;
